import React, { useEffect, useContext } from "react";
import Box from "@material-ui/core/Box";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import AppCardSearch from "./AppCardSearch";
import TablePaginationActions from "./TablePaginationActions";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import TablePagination from "@material-ui/core/TablePagination";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import NmefSpinner from "../../lib/NmefSpinner";
import ApplicationContext from "./ApplicationContext";
import { StyledIconButton } from "./TablePaginationActions";
import AppTable from "./appTable";
import CachedIcon from "@material-ui/icons/Cached";

const useStyles = makeStyles((theme) => ({
	scrollBar: {
		background: "#2E3B55 !important",
		padding: "2px",
		overflowY: "hidden",
		overflowX: "hidden",
		"&::-webkit-scrollbar": {
			width: "6px",
			backgroundColor: "#2E3B55",
		},
		"&::-webkit-scrollbar-track": {
			"-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.3)",
			backgroundColor: "#F5F5F5",
		},
		"&::-webkit-scrollbar-thumb": {
			backgroundColor: "#2E3B55",
		},
	},
	toolbar: {
		padding: "0",
		background: "#2E3B55 !important",
		color: theme.palette.common.white,
		fontWeight: "bold",
	},
}));

export default function ApplicationQueue({
	applicationList,
	isAdminConsole,
	setIsRefresh,
	applicationStatus,
}) {
	const [page, setPage] = React.useState(0);
	const [pageHeight, setPageHeight] = React.useState(10);
	const {
		isSearch,
		totalAppsInQueue,
		queueDrawerOpen,
		toggleQueueDrawer,
	} = useContext(ApplicationContext);
	const handleChangePage = (event, newPage) => {
		if (applicationList?.length <= 10) setPage(0);
		else setPage(newPage);
	};

	const handleChangeRowsPerPage = (event) => {
		//setRowsPerPage(parseInt(event.target.value, 10));
		setPage(0);
	};

	const classes = useStyles();
	useEffect(() => {
		window.addEventListener("resize", onWindowResized);
	}, []);

	useEffect(() => {
		onWindowResized();
	}, [applicationList]);

	const onWindowResized = () => {
		let height = 0;
		let body = window.document.body;
		let element = document.getElementById("qmanager-app-list");
		if (window.innerHeight) {
			height = window.innerHeight - 20;
		} else if (body.parentElement.clientHeight) {
			height = body.parentElement.clientHeight;
		} else if (body && body.clientHeight) {
			height = body.clientHeight;
		}
		setPageHeight(height);
		element.style.height = height - (element.offsetTop + 45) + "px";
	};
	const renderAppCards = () => {
		const doApplicationsExist = applicationList && applicationList?.length > 0;
		applicationList.map((item) => {
			if (item.account_manager_id && typeof item.account_manager_id === "string" && item.account_manager_id?.length !== 2 && item?.account_manager_id !== "-") {
				let splitNames = item.account_manager_id;
				splitNames = splitNames?.split(" ");
				let name = "";
				name = splitNames?.[0].charAt(0).toUpperCase() + splitNames?.[1]?.charAt(0).toUpperCase();
				item.account_manager_id = name
			}
			if (!item?.broker_short_name) {
				item.broker_short_name = "-"
			}

			if (item?.account_manager_id === undefined) {
				item.account_manager_id = "-"
			}
		})

		return (
			<>
				{doApplicationsExist ? (
					<div style={{ paddingLeft: queueDrawerOpen ? "0.75%" : "2%" }}>
						<AppTable
							sx={{ display: "flex", maxHeight: '100%' }}
							onAppOpen={() => toggleQueueDrawer(true)}
							data={applicationList}
							renderAllRows={queueDrawerOpen}
							isAdminConsole={isAdminConsole || false}
							rowsPerPage={20}
							totalAppsInQueue={totalAppsInQueue}
							applicationStatus={applicationStatus}
							pageHeight={pageHeight}
							setIsRefresh={setIsRefresh}
						/>
					</div>
				) : (
					<TableRow>
						<TableCell
							align="center"
							style={{
								padding: "0.1rem",
								border: "none",
								fontWeight: "bold",
							}}>
							Not Found
						</TableCell>
					</TableRow>
				)}
			</>
		);
	};

	return (
		<TableContainer>
			<AppCardSearch />

			<Box
				sx={{
					display: "flex",
					backgroundColor: "#2E3B55",
					justifyContent: "space-between",
					alignItems: "center",
				}}>
				<CachedIcon
					style={{ marginLeft: "10px", color: "white", cursor: "pointer" }}
					onClick={() => {
						setIsRefresh(true);
					}}
				/>
				<Box sx={{ display: "flex", alignItems: "center", marginRight: "5px" }}>
					{queueDrawerOpen ? (
						<StyledIconButton
							onClick={() => toggleQueueDrawer(false)}>
							<ArrowBackIcon htmlColor="white" />
						</StyledIconButton>
					) : (
						<StyledIconButton
							onClick={() => toggleQueueDrawer(true)}>
							<ArrowForwardIcon htmlColor="white" />
						</StyledIconButton>
					)}
				</Box>
			</Box>
			<div id="qmanager-app-list" className={classes.scrollBar}>
				<Table className="uniqueName" aria-label="simple table">
					<TableBody>
						{isSearch ? (
							<TableRow key={0}>
								<TableCell align="left" style={{ padding: 3, border: "none" }}>
									<NmefSpinner />
								</TableCell>
							</TableRow>
						) : (
							<>{renderAppCards()}</>
						)}
					</TableBody>
				</Table>
			</div>
		</TableContainer>
	);
}

ApplicationQueue.propTypes = {
	applicationList: PropTypes.array.isRequired,
};